import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=004d7a1f"
import script from "./VerifyPhone.vue?vue&type=script&lang=ts"
export * from "./VerifyPhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports